import React, {useEffect, useMemo} from 'react';
import { env } from '../../../constants/global.vars';
import { auth } from '../../../store/auth.store';
import {useNavigate} from "react-router";
import paths from "../../../paths";

interface Props {
    ticketId: string;
    gameSlug: string;
    onClose: () => void;
}

const SISAL_CONFIG = {
    WIDGET_PATH: "/numeric-game-widget/numeric-ticket-widget.html"
};

const NumericTickets: React.FC<Props> = ({ ticketId, gameSlug, onClose }) => {
    const navigate = useNavigate()
    const accountId = auth?.member?.id;
    const userToken = auth?.token;

    const ticketUrl = useMemo(() => {
        if (!accountId) return '';

        const wrapperParams = new URLSearchParams({
            gameSlug: gameSlug,
            ticketId: ticketId,
            conto: String(accountId),
            apiUrl: env.accounting_api,
            authToken: userToken || "",
            isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
        });

        return `${window.location.origin}${SISAL_CONFIG.WIDGET_PATH}?${wrapperParams.toString()}`;
    }, [ticketId, accountId, gameSlug, userToken]);

    useEffect(() => {
        const handleSisalMessage = (event: MessageEvent) => {
            const data = event.data;
            if (data.action === "REPLAY") {
                navigate(`${paths.numericgames.url}/${data.gameSlug}`)
            }
        };
        window.addEventListener('message', handleSisalMessage);
        return () => {
            window.removeEventListener('message', handleSisalMessage);
        };
    }, []);

    return (
        <div className="sisal-ticket-container" style={{ width: '100%', height: '100%' }}>
            <div
                style={{width:50, height:70, position:'absolute', right:0, top:0, zIndex: 10}}
                onClick={onClose}
            ></div>
            {ticketUrl && (
                <iframe
                    title="Sisal Ticket Detail"
                    src={ticketUrl}
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    allow="fullscreen; autoplay"
                />
            )}
        </div>
    );
};

export default NumericTickets;